import React from 'react';

import config from 'config';

import LoginPage from '../../_authorizationPages/LoginPage';
import SelectOrganizationPage from '../../_authorizationPages/OrganizationSelectionPage';

const DefaultPage = () => (
  Number(config.org_id)
    ? <LoginPage />
    : <SelectOrganizationPage />
);

export default DefaultPage;